module.exports = __webpack_public_path__ + "static/media/funding-bg.00f53aa4.png";